export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      sale: "Vente",
      rentalLong: "Location longue durée",
      rentalShort: "Location saisonnière",
      consulting: "Cabinet de conseil",
      dashboard: "Tableau de bord",
      login: "Connexion",
      logout: "Déconnexion",
      register: "Inscription",
    },
    home: {
      eyebrow: "Patrimoine immobilier premium",
      title: "L'immobilier,\nréinventé.",
      subtitle: "Quatre métiers. Une vision. Des lieux d'exception, un accompagnement sur-mesure.",
      cta: "Découvrir",
      ctaConsulting: "Notre cabinet",
      exploreTitle: "Explorer nos univers",
      exploreSubtitle: "De l'acquisition au séjour, chaque projet mérite l'excellence.",
      featuredTitle: "À la une",
      featuredSubtitle: "Nos biens d'exception sélectionnés cette semaine.",
      plansTitle: "Agences : choisissez votre plan",
      plansSubtitle: "Des outils pensés pour faire grandir votre activité.",
    },
    pages: {
      sale: {
        title: "Vente immobilière",
        subtitle: "Des biens d'exception, choisis avec exigence.",
      },
      rentalLong: {
        title: "Location longue durée",
        subtitle: "Votre prochain chez-vous, pour 12 mois et plus.",
      },
      rentalShort: {
        title: "Location saisonnière",
        subtitle: "Séjours uniques, adresses privilégiées.",
      },
      consulting: {
        title: "Cabinet de conseil",
        subtitle: "Juridique, conseil, gestion. Une expertise intégrée.",
      },
    },
    filters: {
      location: "Ville",
      anyLocation: "Toutes les villes",
      minPrice: "Prix min",
      maxPrice: "Prix max",
      bedrooms: "Chambres",
      anyBedrooms: "Toutes",
      search: "Rechercher",
      reset: "Réinitialiser",
      noResults: "Aucun bien ne correspond à votre recherche.",
    },
    property: {
      bedrooms: "ch.",
      bathrooms: "sdb",
      surface: "m²",
      perMonth: "/mois",
      perNight: "/nuit",
      viewDetails: "Voir le bien",
      contactAgency: "Contacter l'agence",
      description: "Description",
      amenities: "Équipements",
      location: "Localisation",
      book: "Réserver",
      backTo: "Retour",
    },
    contact: {
      title: "Parlons de votre projet",
      subtitle: "Laissez-nous un message, nous vous répondons sous 24h.",
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      subject: "Objet",
      message: "Message",
      service: "Service concerné",
      submit: "Envoyer",
      success: "Message envoyé. Nous revenons vers vous très vite.",
      error: "Une erreur est survenue.",
    },
    auth: {
      loginTitle: "Bon retour.",
      loginSubtitle: "Connectez-vous à votre espace.",
      registerTitle: "Créer un compte",
      registerSubtitle: "Rejoignez la plateforme en quelques secondes.",
      email: "Email",
      password: "Mot de passe",
      name: "Nom complet",
      loginBtn: "Se connecter",
      registerBtn: "Créer mon compte",
      googleBtn: "Continuer avec Google",
      or: "ou",
      noAccount: "Pas encore de compte ?",
      hasAccount: "Déjà inscrit ?",
    },
    dashboard: {
      title: "Tableau de bord",
      overview: "Vue d'ensemble",
      properties: "Annonces",
      users: "Utilisateurs",
      agencies: "Agences",
      roles: "Rôles",
      messages: "Messages",
      totalProperties: "Annonces",
      totalUsers: "Utilisateurs",
      totalAgencies: "Agences",
      totalMessages: "Messages",
      addProperty: "Ajouter une annonce",
      addAgency: "Ajouter une agence",
      delete: "Supprimer",
      edit: "Modifier",
    },
  },
  en: {
    nav: {
      home: "Home",
      sale: "For sale",
      rentalLong: "Long-term rental",
      rentalShort: "Short stays",
      consulting: "Consulting firm",
      dashboard: "Dashboard",
      login: "Sign in",
      logout: "Sign out",
      register: "Sign up",
    },
    home: {
      eyebrow: "Premium real estate portfolio",
      title: "Real estate,\nreimagined.",
      subtitle: "Four disciplines. One vision. Exceptional places, tailored guidance.",
      cta: "Discover",
      ctaConsulting: "Our firm",
      exploreTitle: "Explore our worlds",
      exploreSubtitle: "From acquisition to stays, every project deserves excellence.",
      featuredTitle: "Featured",
      featuredSubtitle: "This week's curated properties.",
      plansTitle: "Agencies: choose your plan",
      plansSubtitle: "Tools built to grow your business.",
    },
    pages: {
      sale: { title: "Properties for sale", subtitle: "Exceptional properties, thoughtfully selected." },
      rentalLong: { title: "Long-term rentals", subtitle: "Your next home, 12 months or more." },
      rentalShort: { title: "Short stays", subtitle: "Unique stays, privileged addresses." },
      consulting: { title: "Consulting firm", subtitle: "Legal, advisory, management. Integrated expertise." },
    },
    filters: {
      location: "City",
      anyLocation: "All cities",
      minPrice: "Min price",
      maxPrice: "Max price",
      bedrooms: "Bedrooms",
      anyBedrooms: "Any",
      search: "Search",
      reset: "Reset",
      noResults: "No property matches your search.",
    },
    property: {
      bedrooms: "bd",
      bathrooms: "ba",
      surface: "sqm",
      perMonth: "/mo",
      perNight: "/night",
      viewDetails: "View property",
      contactAgency: "Contact agency",
      description: "Description",
      amenities: "Amenities",
      location: "Location",
      book: "Book",
      backTo: "Back",
    },
    contact: {
      title: "Let's talk about your project",
      subtitle: "Leave us a message, we reply within 24h.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Message",
      service: "Service",
      submit: "Send",
      success: "Message sent. We'll get back to you soon.",
      error: "An error occurred.",
    },
    auth: {
      loginTitle: "Welcome back.",
      loginSubtitle: "Sign in to your account.",
      registerTitle: "Create an account",
      registerSubtitle: "Join the platform in seconds.",
      email: "Email",
      password: "Password",
      name: "Full name",
      loginBtn: "Sign in",
      registerBtn: "Create account",
      googleBtn: "Continue with Google",
      or: "or",
      noAccount: "No account yet?",
      hasAccount: "Already registered?",
    },
    dashboard: {
      title: "Dashboard",
      overview: "Overview",
      properties: "Listings",
      users: "Users",
      agencies: "Agencies",
      roles: "Roles",
      messages: "Messages",
      totalProperties: "Listings",
      totalUsers: "Users",
      totalAgencies: "Agencies",
      totalMessages: "Messages",
      addProperty: "Add listing",
      addAgency: "Add agency",
      delete: "Delete",
      edit: "Edit",
    },
  },
};
